import axios from "axios";

// Update privacy setting
export const updatePrivacy = async (privacy, token) => {
  try {
    await axios.put(
      "/privacy",
      { privacy },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok" };
  } catch (error) {
    return { status: "error", message: error.response?.data?.message || "Failed to update privacy" };
  }
};

export const getStoryArchiveSetting = async (token) => {
  try {
    const { data } = await axios.get("/storyArchiveSetting", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return {
      status: "ok",
      saveStoriesToArchive: data?.saveStoriesToArchive !== false,
    };
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Failed to fetch story archive setting",
    };
  }
};

export const updateStoryArchiveSetting = async (saveStoriesToArchive, token) => {
  try {
    const { data } = await axios.put(
      "/storyArchiveSetting",
      { saveStoriesToArchive },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return {
      status: "ok",
      saveStoriesToArchive: data?.saveStoriesToArchive !== false,
    };
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Failed to update story archive setting",
    };
  }
};
export const updateprofilePicture = async (url, token) => {
  try {
    await axios.put(
      `/updateProfilePicture`,
      {
        url,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return "ok";
  } catch (error) {
    console.error("Profile picture update error:", error);
    return error.response?.data?.message || "Failed to update profile picture";
  }
};
export const updateCover = async (url, token) => {
  try {
    await axios.put(
      `/updateCover`,
      {
        url,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return "ok";
  } catch (error) {
    return error.response?.data?.message || error.message || "Failed to update cover photo";
  }
};
export const addFriend = async (id, token) => {
  try {
    await axios.put(
      `/addFriend/${id}`,
      {},

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return "ok";
  } catch (error) {
    return error.response.data.message;
  }
};
export const cancelRequest = async (id, token) => {
  try {
    await axios.put(
      `/cancelRequest/${id}`,
      {},

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return "ok";
  } catch (error) {
    return error.response.data.message;
  }
};
export const follow = async (id, token) => {
  try {
    await axios.put(
      `/follow/${id}`,
      {},

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return "ok";
  } catch (error) {
    console.log(error.response.data.message);
    return error.response.data.message;
  }
};
export const unfollow = async (id, token) => {
  try {
    await axios.put(
      `/unfollow/${id}`,
      {},

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return "ok";
  } catch (error) {
    return error.response.data.message;
  }
};
export const acceptRequest = async (id, token) => {
  try {
    await axios.put(
      `/acceptRequest/${id}`,
      {},

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return "ok";
  } catch (error) {
    return error.response.data.message;
  }
};
export const unfriend = async (id, token) => {
  try {
    await axios.put(
      `/unfriend/${id}`,
      {},

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return "ok";
  } catch (error) {
    return error.response.data.message;
  }
};
export const deleteRequest = async (id, token) => {
  try {
    await axios.put(
      `/deleteRequest/${id}`,
      {},

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return "ok";
  } catch (error) {
    return error.response.data.message;
  }
};
export const search = async (searchTerm, token) => {
  try {
    const { data } = await axios.post(
      `/search/${searchTerm}`,
      {},

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error.response.data.message;
  }
};
export const addToSearchHistory = async (searchUser, token) => {
  try {
    const { data } = await axios.put(
      `/addToSearchHistory`,
      { searchUser },

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error.response.data.message;
  }
};
export const getSearchHistory = async (token) => {
  try {
    const { data } = await axios.get(
      `/getSearchHistory`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error.response.data.message;
  }
};
export const removeFromSearch = async (searchUser, token) => {
  try {
    const { data } = await axios.put(
      `/removeFromSearch`,
      { searchUser },

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error.response.data.message;
  }
};
export const getFriendsPageInfos = async (token) => {
  try {
    const { data } = await axios.get(
      `/getFriendsPageInfos`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return error.response.data.message;
  }
};

export const getUpcomingBirthdays = async (token) => {
  try {
    const { data } = await axios.get(
      `/birthdays/upcoming`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return error.response?.data?.message || "Failed to fetch birthdays";
  }
};

export const getTodaysBirthdays = async (token) => {
  try {
    const { data } = await axios.get(
      `/birthdays/today`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return error.response?.data?.message || "Failed to fetch today's birthdays";
  }
};

export const getFriendSuggestions = async (token) => {
  try {
    const { data } = await axios.get(
      `/suggestions`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return error.response?.data?.message || "Failed to fetch friend suggestions";
  }
};
export const getNotifications = async (token) => {
  try {
    const { data } = await axios.get(`/notifications`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    return error.response.data.message;
  }
};

export const getFriends = async (token) => {
  try {
    const { data } = await axios.get(`/api/friends/list`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    return error.response.data.message;
  }
};
